"use client";

import { Star, ExternalLink } from "lucide-react";
import { EXTERNAL_LINKS } from "@/lib/constants";
import { useTranslations } from "next-intl";

export const TestimonialSection = () => {
  const t = useTranslations("Testimonial");

  return (
    <section
      id="testimonials"
      className="border-y border-border bg-menu-paper"
      aria-labelledby="testimonials-heading"
    >
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="max-w-3xl mx-auto">
          <h2 id="testimonials-heading" className="sr-only">
            {t("testimonialTitle") || "Customer Testimonials"}
          </h2>
          <div className="relative p-8 md:p-10 rounded-2xl bg-gradient-to-b from-background to-background/90 border border-border shadow-md overflow-hidden">
            {/* Menu-like texture background */}
            <div
              className="absolute inset-0 bg-menu-texture opacity-20"
              aria-hidden="true"
            ></div>

            {/* Menu corner decorations */}
            <div
              className="absolute top-4 left-4 w-12 h-12 border-t border-l border-primary/30"
              aria-hidden="true"
            ></div>
            <div
              className="absolute top-4 right-4 w-12 h-12 border-t border-r border-primary/30"
              aria-hidden="true"
            ></div>
            <div
              className="absolute bottom-4 left-4 w-12 h-12 border-b border-l border-primary/30"
              aria-hidden="true"
            ></div>
            <div
              className="absolute bottom-4 right-4 w-12 h-12 border-b border-r border-primary/30"
              aria-hidden="true"
            ></div>

            <div className="relative">
              <div className="flex justify-center mb-6">
                <div
                  className="w-16 h-1 bg-gradient-to-r from-transparent via-primary/50 to-transparent"
                  aria-hidden="true"
                ></div>
              </div>

              <div
                className="flex justify-center space-x-1 text-yellow-400 mb-4"
                aria-label="5 out of 5 stars rating"
              >
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="fill-yellow-400 h-5 w-5"
                    aria-hidden="true"
                  />
                ))}
              </div>

              <blockquote className="text-xl md:text-2xl text-card-foreground font-medium mb-6 text-center font-display">
                &ldquo;{t("quote")}&rdquo;
              </blockquote>

              <footer className="text-center">
                <cite>
                  <p className="font-semibold font-display">
                    {t("restaurantName")}
                  </p>
                  <p className="text-sm text-muted-foreground mb-4 font-sans">
                    <a
                      href={EXTERNAL_LINKS.whatTheDickens.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary hover:text-primary/90"
                    >
                      {EXTERNAL_LINKS.whatTheDickens.text}
                    </a>
                    <span className="mx-2" aria-hidden="true">
                      •
                    </span>
                    {t("restaurantDescription")}
                  </p>
                </cite>

                <div className="mt-6">
                  <a
                    href={EXTERNAL_LINKS.whatTheDickens.menuPreview}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm px-4 py-2 rounded-full bg-menu-accent text-menu-ink hover:bg-menu-accent/80 transition-colors"
                    aria-label={`${t("previewMenu")} - ${t("restaurantName")}`}
                  >
                    <span>{t("previewMenu")}</span>
                    <ExternalLink className="w-3 h-3" aria-hidden="true" />
                  </a>
                </div>
              </footer>

              <div className="flex justify-center mt-6">
                <div
                  className="w-16 h-1 bg-gradient-to-r from-transparent via-primary/50 to-transparent"
                  aria-hidden="true"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
